import { render } from "./ComparativeProfitAndLossList.vue?vue&type=template&id=19c5d4cc"
import script from "./ComparativeProfitAndLossList.vue?vue&type=script&lang=js"
export * from "./ComparativeProfitAndLossList.vue?vue&type=script&lang=js"

import "./ComparativeProfitAndLossList.vue?vue&type=style&index=0&id=19c5d4cc&lang=css"

import exportComponent from "C:\\projects\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Company\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__